import { useMemo } from 'react';
import { useWorkerInformationQuery } from '../../../graphql/graphql';
import { useAppContext } from '../../../Services/AppContext';

export default function useElectronicSignature() {
	const { userData } = useAppContext();
	const { data, isLoading } = useWorkerInformationQuery({
		userId: userData.id,
	});

	const isQualifiedCertificateForElectronicSignatureUsed = useMemo(() => {
		return (
			data?.user?.meta?.some(
				item =>
					item?.key === 'useQualifiedCertificateForElectronicSignature' &&
					item?.value === true,
			) ?? false
		);
	}, [data]);

	return { isQualifiedCertificateForElectronicSignatureUsed, isLoading };
}
